<script>
import { Doughnut } from "vue-chartjs";

/**
 * This component extends the ChartJS Doughnut and provides the custom options and takes a prop with the actual chart data and component-defined chart size.
 *
 * ## `chartData` prop object structure
 *
 * The `chartData` object structure expects the following:
 *
 * ```javascript
 * chartData: {
 * 	datasets: [
 * 		{
 * 			data: ["5.79", "7.80"],
 * 			backgroundColor: ["#23C6AF", "#1D6D69"]
 * 		}
 * 	]
 * }
 * ```
 */
export default {
	name: "DoughnutChart",
	extends: Doughnut,
	props: {
		/**
		 * This Object contains the data and data background colors for the doughnut chart. The order of the data and backgroundColor arrays in the dataset object must align. See the object structure example above.
		 */
		chartData: { type: Object },

		/**
		 * The chart diameter in pixels. The Doughnut Chart component watches this prop for a change and redraws at the updated size. The string should match the following for a 280 pixel-wide doughnut chart: "280px".
		 */
		chartDiameter: String,
		chartAriaLabel: {
			type: String,
			default: "Doughnut chart"
		}
	},
	data: function () {
		return {
			loaded: true,
			options: {
				layout: {
					padding: 0
				},
				responsive: true,
				maintainAspectRatio: false,
				responsiveAnimationDuration: 0,
				animation: {
					duration: 0
				},
				hover: {
					animationDuration: 0
				},
				cutoutPercentage: 60,
				legend: {
					display: false
				},
				tooltips: {
					enabled: false
				},
				title: {
					display: false
				},
				elements: {
					arc: {
						borderWidth: 0
					}
				}
			}
		};
	},
	mounted() {
		this.renderChart(this.chartData, this.options);
		this.setSize(this.chartDiameter);
		this.$data._chart.canvas.setAttribute("role", "img");
		this.$data._chart.canvas.setAttribute("aria-label", this.chartAriaLabel);
	},
	watch: {
		/* Calls setSize when chartDiameter changes */
		chartDiameter: function () {
			this.setSize(this.chartDiameter);
		}
	},
	methods: {
		setSize(chartDiameter) {
			this.$data._chart.canvas.parentNode.style.height = chartDiameter;
			this.$data._chart.canvas.parentNode.style.width = chartDiameter;
		}
	}
};
</script>
